import { useEffect, useState } from 'react';
import { matchRingColor } from './jobCardUtils';

/**
 * Circular match-score gauge. Arc fills to the score on mount, colored by tier.
 * Replaces the flat % pill.
 */
export default function MatchRing({ score, size = 44, stroke = 4 }) {
  const [shown, setShown] = useState(0);
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const color = matchRingColor(score);

  useEffect(() => {
    const t = setTimeout(() => setShown(score), 60);
    return () => clearTimeout(t);
  }, [score]);

  const offset = circ * (1 - Math.max(0, Math.min(100, shown)) / 100);

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }} title={`${score}% match`}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--tandm-line)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.9s var(--tandm-ease)' }}
        />
      </svg>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1,
        }}
      >
        <span style={{ fontSize: size * 0.3, fontWeight: 800, color, letterSpacing: '-0.03em' }}>{score}</span>
        <span style={{ fontSize: size * 0.17, fontWeight: 600, color: 'var(--tandm-faint)', marginTop: 1 }}>match</span>
      </div>
    </div>
  );
}
